export const DASHBOARD_HERO_HEIGHT = 272;

export const DASHBOARD_TRANSITION_DURATION_MS = 300;
